import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";
import {
  ActiveInactive_Record,
  delete_Record,
  errorMessage,
} from "../CommonFunctions";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post } from "../../../helpers/api_helper";

import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import {
  POST_GetDepartmentDropDownList,
  POST_GetTestMasterList,
  POST_ProductGroupDropDownListByDepartmentID,
  POST_TestMasterActiveInActive,
  POST_TestMasterDelete,
  POST_TestMasterExport,
} from "../../../helpers/url_helper";
import { useFilter } from "../../../../context/FilterContext";

const TestMaster = () => {
  const [showFilter, setShowFilter] = useState(true);
  const { filter, updateFilter } = useFilter();

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "test-master" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "test-master" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "test-master" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "test-master" ? filter?.orderBy : "asc"
  );

  const [testMasterList, setTestMasterList] = useState([]);

  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [productGroupOptions, setProductGroupOptions] = useState([]);

  const [isReset, setIsReset] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const yesNoOptions = [
    { label: "All", value: -1 },
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  const DraftOptions = [
    { label: "All", value: 0 },
    { label: "Yes", value: 1 },
  ];

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      Status: filter && filter?.page == "test-master" ? filter?.Status : -1,
      Search: filter && filter?.page == "test-master" ? filter?.Search : "",
      IsNABL: filter && filter?.page == "test-master" ? filter?.IsNABL : -1,
      IsDraft: filter && filter?.page == "test-master" ? filter?.IsDraft : 0,
      DepartmentIDEncrypted:
        filter && filter?.page == "test-master"
          ? filter?.DepartmentIDEncrypted
          : "",
      ProductGroupIDEncrypted:
        filter && filter?.page == "test-master"
          ? filter?.ProductGroupIDEncrypted
          : "",
      // Search: "",
      // Status: -1,
      // IsNABL: -1,
      // DepartmentIDEncrypted: "",
      // ProductGroupIDEncrypted: "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: {
      Search,
      Status,
      IsNABL,
      IsDraft,
      DepartmentIDEncrypted,
      ProductGroupIDEncrypted,
    },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      Search: "",
      Status: -1,
      IsNABL: -1,
      IsDraft: 0,
      DepartmentIDEncrypted: "",
      ProductGroupIDEncrypted: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "test-master",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      Status: Status,
      Search: Search ? Search : "",
      DepartmentIDEncrypted: DepartmentIDEncrypted ? DepartmentIDEncrypted : "",
      ProductGroupIDEncrypted: ProductGroupIDEncrypted
        ? ProductGroupIDEncrypted
        : "",
      IsNABL: IsNABL,
      IsDraft: IsDraft,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Status,
      NABL: IsNABL,
      IsDraft: IsDraft,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      DepartmentIDEncrypted: DepartmentIDEncrypted,
      ProductGroupIDEncrypted: ProductGroupIDEncrypted,
    };
    await post(POST_GetTestMasterList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setTestMasterList(response?.TestMasterList);
        setIsLoading(false);
        if (page > 1 && response?.TestMasterList?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  useEffect(() => {
    getDepartmentList();
  }, []);

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getDepartmentList = async () => {
    setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item.DepartmentName,
              value: item.DepartmentIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (DepartmentIDEncrypted) {
      getProductGroupDDL(DepartmentIDEncrypted);
    } else {
      setProductGroupOptions([]);
      formikFilter.setFieldValue("ProductGroupIDEncrypted", "");
    }
  }, [DepartmentIDEncrypted]);

  const getProductGroupDDL = (DepartmentID) => {
    setIsLoading(true);
    post(POST_ProductGroupDropDownListByDepartmentID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      DepartmentIDEncrypt: DepartmentIDEncrypted,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProductGroupOptions(
            response?.ProductGroupDropDownList?.map((item) => ({
              label: item.ProductGroupName,
              value: item.ProductGroupIDEncrypt,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      Search: Search,
      Status: Status,
      NABL: IsNABL,
      IsDraft: IsDraft,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      DepartmentIDEncrypted: DepartmentIDEncrypted,
      ProductGroupIDEncrypted: ProductGroupIDEncrypted,
    };
    post(POST_TestMasterExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          //swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const getResetData = async () => {
  //   setIsLoading(true);

  //   // formikFilter.resetForm();
  //   formikFilter.setValues({
  //     Search: "",
  //     Status: -1,
  //     IsNABL: -1,
  //     DepartmentIDEncrypted: "",
  //     ProductGroupIDEncrypted: "",
  //   });

  //   setCurrentPage(1);
  //   setSortBy("");
  //   setOrderBy("asc");

  //   setIsReset(true);
  // };

  // useEffect(() => {
  //   if (isReset == true) {
  //     getData(currentPage, currentSizePerPage);
  //     setIsReset(false);
  //   }
  // }, [isReset]);

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Test Master</h4>
              <div className="d-flex align-items-center">
                {/* <button
                  type="button"                 
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getResetData();
                  }}
                >
                  <i className="fa fa-window-restore" aria-hidden="true"></i>
                  {"  "}
                  Reset
                </button> */}
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getResetData();
                  }}
                >
                  <i className="fa fa-window-restore" aria-hidden="true"></i>
                  {"  "}
                  Reset
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getData();
                  }}
                >
                  <i className="fa-solid fa-refresh me-2"></i> Reload
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 22 && x?.IsExport)
                  ?.length > 0 ? (
                  <Link
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link>
                ) : (
                  ""
                )}
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 22 && x?.IsAdd)?.length >
                  0 ? (
                  <Link
                    to="/add-test-master"
                    className="btn btn-outline-primary btn-sm"
                  >
                    <i className="fa-solid fa-plus"></i> Add Test Master
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0 pb-0">
              {showFilter ? (
                <div>
                  <FormikProvider value={formikFilter}>
                    <Form onSubmit={formikFilter.handleSubmit}>
                      <Row className="me-0">
                        <Col lg={2}>
                          <Field
                            label="Search"
                            name="Search"
                            placeholder={"Search here..."}
                            component={CustomInput}
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="Department"
                            name="DepartmentIDEncrypted"
                            placeholder={"Select Department"}
                            component={CustomSelect}
                            options={departmentOptions}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="Material Group"
                            name="ProductGroupIDEncrypted"
                            placeholder={"Select Material Group"}
                            component={CustomSelect}
                            options={productGroupOptions}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={1}>
                          <Field
                            label="Status"
                            name="Status"
                            placeholder={"Select Status"}
                            options={statusOptions}
                            component={CustomSelect}
                            isClearable={false}
                            menuPosition="fixed"
                          />
                        </Col>

                        <Col lg={1}>
                          <Field
                            label="NABL"
                            name="IsNABL"
                            placeholder={"Select NABL"}
                            options={yesNoOptions}
                            component={CustomSelect}
                            isClearable={false}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={1}>
                          <Field
                            label="Draft"
                            name="IsDraft"
                            placeholder={"Select Draft"}
                            options={DraftOptions}
                            component={CustomSelect}
                            isClearable={false}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={2}>
                          <label className="mb-1">&nbsp;</label>
                          <div className="d-flex">
                            <div className="d-lg-block">
                              <Link
                                className="btn btn-primary btn-sm"
                                onClick={(e) => {
                                  getData();
                                }}
                              >
                                <i
                                  className="fa fa-search"
                                  aria-hidden="true"
                                ></i>{" "}
                                Search
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              ) : (
                ""
              )}
              <div
                id="TestMaster-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="TestMaster-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="6%"></th>
                      <th
                        style={{
                          width: "32%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("TestName");
                        }}
                      >
                        Test Name{" "}
                        <span className="ml-1">
                          {sortBy == "TestName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "24%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("DepartmentName");
                        }}
                      >
                        Department{" "}
                        <span className="ml-1">
                          {sortBy == "DepartmentName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "24%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("ProductGroupName");
                        }}
                      >
                        Material Group{" "}
                        <span className="ml-1">
                          {sortBy == "ProductGroupName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      {/* <th
                        style={{
                          width: "24%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("MaterialTypeName");
                        }}
                      >
                        Material Type{" "}
                        <span className="ml-1">
                          {sortBy == "MaterialTypeName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th> */}
                      {AuthUser?.Permissions?.DT == 1 && (
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("MachiningRequired");
                          }}
                        >
                          Machining Required{" "}
                          <span className="ml-1">
                            {sortBy == "MachiningRequired" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      )}
                      <th
                        style={{
                          width: "6%",
                          cursor: "pointer",
                          textAlign: "left",
                        }}
                        onClick={() => {
                          handleClickSorting("IsNABL");
                        }}
                      >
                        NABL{" "}
                        <span className="ml-1">
                          {sortBy == "IsNABL" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      {AuthUser?.Permissions?.DT == 1 &&
                        AuthUser?.Permissions?.NDT == 1 && (
                          <th
                            style={{
                              width: "6%",
                              cursor: "pointer",
                              textAlign: "left",
                            }}
                            onClick={() => {
                              handleClickSorting("TestType");
                            }}
                          >
                            Test Type{" "}
                            <span className="ml-1">
                              {sortBy == "TestType" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                        )}
                    </tr>
                  </thead>
                  <tbody>
                    {testMasterList?.length > 0 ? (
                      testMasterList?.map((item, indx) => (
                        <tr key={indx}>
                          <td>
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 22 && x?.IsEdit
                            )?.length > 0 ? (
                              <Link
                                to={`/edit-test-master/${window.btoa(
                                  item.TestMasterIDEncrypt
                                )}`}
                                className="icon-box icon-box-md me-1"
                                title="Edit"
                              >
                                {SVGICON.EditPrimary}
                              </Link>
                            ) : (
                              ""
                            )}
                            {item?.IsDraft == 0 ? (
                              AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 22 && x?.IsActive
                              )?.length > 0 ? (
                                <Link
                                  to="#"
                                  className={`icon-box icon-box-md me-1`}
                                  title={
                                    item.IsActive == true
                                      ? "Active"
                                      : "Inactive"
                                  }
                                  onClick={() => {
                                    ActiveInactive_Record(
                                      item.IsActive,
                                      POST_TestMasterActiveInActive,
                                      {
                                        TestMasterIDEncrypt:
                                          item.TestMasterIDEncrypt,
                                        IsActive: !item.IsActive,
                                        ModifiedByEncrypted:
                                          AuthUser?.ReferenceIDEncrypt
                                            ? AuthUser?.ReferenceIDEncrypt
                                            : "0",
                                      },
                                      setIsLoading,
                                      fnCallback,
                                      item.TestName
                                    );
                                  }}
                                >
                                  <i
                                    className={`fa fa-circle fs-15 ${
                                      item.IsActive == true
                                        ? "text-success"
                                        : "text-danger"
                                    }`}
                                  ></i>
                                </Link>
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 22 && x?.IsDelete
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                className="icon-box icon-box-md me-1"
                                title="Delete"
                                onClick={() => {
                                  delete_Record(
                                    POST_TestMasterDelete,
                                    {
                                      TestMasterIDEncrypt:
                                        item.TestMasterIDEncrypt,
                                      ModifiedByEncrypted:
                                        AuthUser?.ReferenceIDEncrypt
                                          ? AuthUser?.ReferenceIDEncrypt
                                          : "0",
                                    },
                                    setIsLoading,
                                    fnCallback,
                                    item.TestName
                                  );
                                }}
                              >
                                {SVGICON.DeleteDanger}
                              </Link>
                            ) : (
                              ""
                            )}
                            {item?.IsDraft == 0 ? (
                              AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 22 && x?.IsEdit
                              )?.length > 0 ? (
                                <Link
                                  to={`/copy-test-master/${window.btoa(
                                    item.TestMasterIDEncrypt
                                  )}`}
                                  className="icon-box icon-box-md me-1"
                                  title="Copy"
                                >
                                  {SVGICON.Copy}
                                </Link>
                              ) : (
                                ""
                              )
                            ) : (
                              <label
                                className="me-1 badge-info badge p-0"
                                style={{ color: "#ffffff", minWidth: "50px" }}
                              >
                                Draft
                              </label>
                            )}
                          </td>
                          <td> {item?.TestName}</td>
                          <td> {item?.DepartmentName}</td>
                          <td> {item?.ProductGroupName}</td>
                          {/* <td
                            style={{ cursor: "pointer" }}
                            className="popupOverlay"
                          >
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              key={indx}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {item.MaterialTypeName}
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>{item.MaterialTypeName}</span>
                            </OverlayTrigger>
                          </td> */}
                          {AuthUser?.Permissions?.DT == 1 && (
                            <td> {item?.MachiningRequired ? "Yes" : "No"}</td>
                          )}
                          <td style={{ textAlign: "left" }}>
                            {item?.IsNABL ? "Yes" : "No"}
                          </td>
                          {AuthUser?.Permissions?.DT == 1 &&
                            AuthUser?.Permissions?.NDT == 1 && (
                              <td style={{ textAlign: "left" }}>
                                {item?.TestType}
                              </td>
                            )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-sm-flex text-center justify-content-between align-items-center">
                  <CustomSizePerPage
                    getData={getData}
                    currentSizePerPage={currentSizePerPage}
                  />
                  <div className="dataTables_info">
                    Showing{" "}
                    {recordCount > 0
                      ? (currentPage - 1) * currentSizePerPage + 1
                      : 0}{" "}
                    to{" "}
                    {recordCount > currentPage * currentSizePerPage
                      ? currentPage * currentSizePerPage
                      : recordCount}{" "}
                    of {recordCount} entries
                  </div>
                  <CustomPaginationButtons
                    totalPages={recordCount / currentSizePerPage}
                    currentPage={currentPage}
                    currentSizePerPage={currentSizePerPage}
                    getData={getData}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default TestMaster;
